import React, { useContext, useState } from 'react';
import { TextField, TextFieldTheme } from 'wix-ui-tpa/cssVars';
import { Search } from '@wix/wix-ui-icons-common/on-stage';
import { ISettingsContextValue } from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import settingsParams from '../../settingsParams';
import { st, classes } from '../Widget.st.css';
import constants from '../../../../constants';
import { useEnvironment, useBi, useTranslation } from '@wix/yoshi-flow-editor';
import { faqSearch } from '@wix/bi-logger-labs-data/v2';
import { DATA_HOOKS } from '../../../../constants/dataHooksElements';
import stylesParams from '../../stylesParams';
import { AppContext } from '../SettingsProvider/SettingsProvider';
import { useLayoutType } from '../../../../hooks/useLayoutType';
import { CategoriesPosition } from '../../../../enums';

const SearchWrapper = (props: {
  onSearchChange: (searchTerm: string) => void;
}) => {
  const { isEditor3, searchTermResponse } = useContext(AppContext);
  const logger = useBi();
  const { onSearchChange } = props;
  const { isMobile } = useEnvironment();
  const settings: ISettingsContextValue = useSettings();
  const styles = useStyles();
  const { t } = useTranslation();
  const { text, show } = settings.get(settingsParams.searchBar);
  const searchBarText = isEditor3
    ? settings.get(settingsParams.searchBarText)
    : text;
  const showSearchStyleParam = styles.get?.(stylesParams.showSearchBar) ?? true;
  const showSearch = showSearchStyleParam && show;
  const [searchTerm, setSearchTerm] = useState('');

  const resultsCount = searchTermResponse
    ? searchTermResponse.questionEntries?.length || 0
    : 0;
  const handleSearchChange = (e: any) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearchChange(value);
    logger.report(faqSearch({}));
  };
  const { categoriesPosition } = useLayoutType(isEditor3);
  const sideCategoriesPosition = categoriesPosition === CategoriesPosition.SIDE;
  return (
    <>
      {showSearch && (
        <>
          <TextField
            tabIndex={0}
            data-hook={DATA_HOOKS.WIDGET_SEARCH_ELEMENT}
            className={st(classes.search, {
              isSideCategoriesPosition: sideCategoriesPosition,
              mobile: isMobile,
            })}
            value={searchTerm}
            theme={TextFieldTheme.Line}
            onChange={handleSearchChange}
            placeholder={searchBarText}
            suffix={<Search />}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearchChange(searchTerm);
              }
            }}
          />
          {searchTerm && (
            <div
              role="status"
              aria-live="polite"
              aria-atomic="true"
              className={st(classes.accessibility__resultsCount)}
            >
              {t('widget.accessibility.resultsCount', { resultsCount })}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SearchWrapper;
